import React, { useEffect, useState } from 'react';
import { Modal } from "@mui/material";
import { EditModal } from './EditModal';
import { Edit } from '@mui/icons-material';
import {  IconButton } from "@mui/material";
import { Item, Serial, SnaiV } from 'Models';
import { ItemService, SerialService } from 'Services';
import { catchError, finalize, tap } from "rxjs/operators";
import { forkJoin } from "rxjs";
import _ from 'lodash';
import { useTranslation } from "react-i18next";
import { useCurrentUser, useUsers, CAEModal } from '@cae/component-library';

export interface EditButtonProps {
    rowData: SnaiV;
    handleRefresh: Function;
    serials: Serial[];
    isAdmin: boolean;
}
export interface SerialContainerDataState {
    itemChange:Item[],
    serialInsert: Serial[],
    serialUpdate: Serial[],
    serialDelete: Serial[],
    serialRemaining: Serial[]
}
export const EditButton: React.FC<EditButtonProps> = ({ rowData, handleRefresh, serials, isAdmin }) => {    
    const { t } = useTranslation("snaiV");
    const {user } = useCurrentUser();
    const [open, setOpen] = React.useState(false);    
    const [item, setItem] = React.useState<Item>(new Item({
        id: rowData.itemId,
        projectId: rowData.itemProjectId,
        itemNumber: rowData.itemItemNumber,
        isHott: rowData.isHott,
        isPo: rowData.isPo,
        updatedBy: rowData.updatedBy,
        updatedDate: rowData.updatedDate
    }));
    const [serialDataContainer, setSerialDataContainer] = React.useState<SerialContainerDataState>({
        itemChange:[],
        serialInsert: [],
        serialUpdate: [],
        serialDelete: [],
        serialRemaining: []
    });
    useEffect(() => {
        setSerialDataContainer(prevState => ({ ...prevState, serialRemaining: _.cloneDeep(serials.filter(s => s.itemId === rowData.itemId)) }))
    }, [serials,rowData]);
    const handleOnClickSave = () => {
        if (serialDataContainer.itemChange.length > 0 ||serialDataContainer.serialInsert.length > 0 || serialDataContainer.serialUpdate.length > 0 || serialDataContainer.serialDelete.length > 0) {
            item.updatedBy = user.userId;
            const observable = forkJoin({
                savedItem: ItemService.SaveItem(serialDataContainer.itemChange[serialDataContainer.itemChange.length-1]||item),
                deletedSerials: SerialService.SaveSerials(serialDataContainer.serialDelete),
                updatedSerials: SerialService.SaveSerials(serialDataContainer.serialUpdate),
                insertedSerials: SerialService.InsertSerials(serialDataContainer.serialInsert),
            });
            observable.pipe(
                tap(response => {
                    handleRefresh(rowData, response.savedItem, [...serialDataContainer.serialRemaining, ...response.updatedSerials, ...response.insertedSerials, ...response.deletedSerials]);
                    setSerialDataContainer((prevState: any) => ({ ...prevState, itemChange:[], serialInsert: [], serialUpdate: [], serialDelete: [], serialRemaining: _.cloneDeep(serials.filter(s => s.itemId === rowData.itemId)) }));
                    setOpen(false);
                }),
                catchError(error => {
                    setOpen(false);
                    return Promise.reject(error);
                }),
                finalize(() => { })
            ).subscribe();
        }
    };
    const handleOnClickClose = React.useCallback(() => {
        setOpen(false);
    }, []);
    const handleOpen = React.useCallback(() => {
        isAdmin ? setOpen(true) : setOpen(false);
    }, [isAdmin]);
    return (
        <>
            <IconButton disabled={!isAdmin} size={"small"} color='inherit' onClick={handleOpen}>                
                <Edit />
            </IconButton>

            <CAEModal
                onClose={handleOnClickClose}
                actionButtonAction={serialDataContainer.itemChange.length > 0 ||serialDataContainer.serialInsert.length > 0 || serialDataContainer.serialUpdate.length > 0 || serialDataContainer.serialDelete.length > 0?handleOnClickSave:undefined}
                actionButtonText={t("save")}
                cancelButtonAction={handleOnClickClose}
                cancelButtonText={t("cancel")}
                open={open}
                fullWidth
                maxWidth="sm"
                setOpen={setOpen}
                title={`Item: ${rowData.itemNumber}`}
                contentType="node"
                >
                <EditModal item={item} setItem={setItem} serials={serials}
                                rowData={rowData} serialDataContainer={serialDataContainer} setSerialDataContainer={setSerialDataContainer} />
            </CAEModal>           
        </>
    );
}